const SuperRally = ({ lap }: any) => {
  if (lap != null) {
    if (lap.isSuperRally) return <span className="sr">SR</span>;
    if (lap.OriginalLapTime != null)
      return (
        <span className="sr sro" title={lap.OriginalLapTime}>
          SR
        </span>
      );
  }
  return <></>;
};

export default SuperRally;
